import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const IncidentGuard = ({ children, ...rest }) => {
  const token = localStorage.getItem("token:data");

  const { profile } = useSelector((state) => state.users);

  let isIncidentAdminGuard = profile
  ? (profile && profile.role &&
      ((profile.role.map((role) => role.name).includes("admin")) || (profile.role.map((role) => role.name).includes("incident_admin")))
    )
  : false;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        token && isIncidentAdminGuard ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: {
                from: location,
              },
            }}
          />
        )
      }
    />
  );
};

export default IncidentGuard;
